'use client';
import { Logo } from '@/components/ui/Logo';

import { useState } from 'react';
import Link from 'next/link';
import toast from 'react-hot-toast';
import { useI18n } from '@/lib/i18n/context';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useI18n();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const d = await res.json();
        toast.error(d.error || 'Có lỗi xảy ra');
        return;
      }
      setSent(true);
    } finally {
      setLoading(false);
    }
  };
  const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden">
      <div className="w-full max-w-sm relative z-10">
        <div className="text-center mb-8">
          <Link href="/" className="inline-block"><Logo name={appName} size="lg" /></Link>
          <p className="text-gray-500 text-sm mt-2">{t.auth.forgotPassword.title}</p>
        </div>

        <div className="bg-surface-900 border border-white/5 rounded-3xl p-8 shadow-2xl">
          {sent ? (
            <div className="text-center py-4">
              <div className="text-5xl mb-4">📧</div>
              <h2 className="font-semibold text-white text-lg mb-2">{t.auth.forgotPassword.emailSent}</h2>
              <p className="text-gray-400 text-sm leading-relaxed">
                {t.auth.forgotPassword.checkEmail.replace('{email}', email)}
              </p>
              <Link href="/login" className="block mt-6 text-brand-400 hover:text-brand-300 text-sm transition-colors">
                ← {t.auth.forgotPassword.backToLogin}
              </Link>
            </div>
          ) : (
            <>
              <p className="text-gray-400 text-sm mb-6 leading-relaxed">
                {t.auth.forgotPassword.instructions}
              </p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm text-gray-400 mb-1.5">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    required
                    className="w-full bg-surface-800 border border-surface-700 rounded-2xl px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500/20 transition-colors"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-gradient-brand text-white font-medium py-3 rounded-2xl hover:brightness-110 transition-all disabled:opacity-60"
                >
                  {loading ? t.auth.forgotPassword.sending : t.auth.forgotPassword.sendLink}
                </button>
              </form>
              <p className="text-center text-sm text-gray-500 mt-6">
                <Link href="/login" className="text-brand-400 hover:text-brand-300 transition-colors">
                  ← {t.auth.forgotPassword.backToLogin}
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
